import React from 'react';

import { HashRouter as Router, useLocation } from 'react-router-dom';

import { NavigationProvider } from './contexts/navigation';
import { UserProvider } from './contexts/user';


import { useScreenSizeClass } from './utils/media-query';
import { Content } from './Content';
import { UnauthenticatedContent } from './UnauthenticatedContent';

import 'devexpress-gantt/dist/dx-gantt.css';
import './styles.scss';
import './theme/theme';
import { useThemeContext, ThemeContext } from './theme/theme';
import deMessages from "devextreme/localization/messages/de.json";
import { locale, loadMessages } from "devextreme/localization";
import { MsalProvider, useIsAuthenticated } from "@azure/msal-react";


function RootApp() {
  console.log('RootApp loaded');
  const isLoginForm = [
    'login',
    'reset-password',
    'create-account',
  ].includes(useLocation().pathname.substring(1));


  const isAuthenticated = useIsAuthenticated();
  // Show loading spinner while authentication is being determined


  if (isAuthenticated) {
    return <Content />;
  } else {
    console.log('User is not authenticated, showing unauthenticated content');
    return <UnauthenticatedContent />;
  }


}

export const App = ({ pca }) => {
  const screenSizeClass = useScreenSizeClass();
  const themeContext = useThemeContext();
  loadMessages(deMessages);
  locale(navigator.language);
  console.log('Load Router/App');
  return (
    <Router>
      <ThemeContext.Provider value={themeContext}>
        <MsalProvider instance={pca}>
          <NavigationProvider>
            <UserProvider>
              <div className={`app ${screenSizeClass}`}>
                {
                  themeContext.isLoaded ? <RootApp /> : ''
                }
              </div>
            </UserProvider>
          </NavigationProvider>
        </MsalProvider>
      </ThemeContext.Provider>
    </Router>
  );
};
